
























































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";
import ExpandableView from "../controls/ExpandableView.vue"
import CategoryTypeSelect from "../general/CategoryTypeSelect.vue";
import SettingsCategoryTypeDetails from "./SettingsCategoryTypeDetails.vue";
import DatePeriodSelectOverlay from "../general/DatePeriodSelectOverlay.vue";

import DateFormatter from "../../shared/DateFormatter";
import { WeekDay, AllWeekDays, WeekDayNames } from "../../shared/WeekDay";
import { Month, MonthNames } from "../../shared/Month";
import ModulesJson from "../../shared/ModulesJson";
import SettingsJson, { getRentalTimeSlotsAtWeekDay } from "../../shared/SettingsJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import BusinessHoursJson, { defaultBusinessHoursJson } from "../../shared/BusinessHoursJson";

import { validateSettingsJson } from "../../shared/SettingsJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import ExpandableViewVue from "../controls/ExpandableView.vue";

export default Vue.extend({
  name: "SettingsRental",
  components: {
    PointerMenu,
    Loading,
    ExpandableView,
    CategoryTypeSelect,
    SettingsCategoryTypeDetails,
    DatePeriodSelectOverlay,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    userActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      UserPermissionRank: UserPermissionRank,
      WeekDay: WeekDay,
      AllWeekDays: AllWeekDays,
      WeekDayNames: WeekDayNames,
      MonthNames: MonthNames,
      CategoryTypeType: CategoryTypeType,
      getRentalTimeSlotsAtWeekDay: getRentalTimeSlotsAtWeekDay,
      settingsData: null as SettingsJson | null,
      cachedRentalBookingUntilDate: null as string | null,
      reloadCategoryTypes: new Date() as Date,
      showCategoryTypeDetails: false as boolean,
      showDatePeriodSelect: false as boolean,
      selectedCategoryTypeId: null as number | null,
      categoryTypeDetailsMode: "read",
      toValidate: {} as any,
      validation: null as ValidationResult<SettingsJson> | null,
      hasChanges: false as boolean,
      showHints: {},
      isSaveDataLoading: false,
    };
  },
  created() {
    this.$emit("resetAppFrameButtons");
    this.loadData();
  },
  mounted() {},
  methods: {
    /*** START: details view ***/
    toggleCategoryTypeDetails() {
      this.showCategoryTypeDetails = !this.showCategoryTypeDetails;
      if (this.showCategoryTypeDetails == false) {
        this.reloadCategoryTypes = new Date();
      }
    },

    openCategoryTypeDetails(item: CategoryTypeJson | null, mode: string) {
      if (item != null) {
        this.selectedCategoryTypeId = item.ID;
      } else {
        this.selectedCategoryTypeId = null;
      }

      this.categoryTypeDetailsMode = mode;
      this.toggleCategoryTypeDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadSettings();
    },

    async loadSettings() {
      this.settingsData = null;

      try {
        this.settingsData = await this.restClient.getSettings();

        this.$nextTick(() => {
          this.hasChanges = false;
        });
      } catch (e) {
        alert(e.message);
      }
    },

    async saveAppSettings() {
      if (this.settingsData != null) {
        this.sortBusinessHours();
        this.validation = validateSettingsJson(this.settingsData);

        if (this.validation != null && this.validation.isValid == true) {
          this.isSaveDataLoading = true;

          try {
            this.settingsData = await this.restClient.saveSettings(this.settingsData);

            this.$emit("reloadSettings");

            this.$nextTick(() => {
              this.hasChanges = false;
            });
          } catch (e) {
            alert("Speichern fehlgeschlagen: " + e.message);
          }

          this.isSaveDataLoading = false;
        } else {
          alert("Die Daten konnten nicht gespeichert werden. Bitte prüfen Sie Ihre Angaben.");
        }
      }
    },

    discardChanges() {
      this.toValidate = {};
      this.loadSettings();
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.settingsData != null) {
        this.validation = validateSettingsJson(this.settingsData);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    addRentalAccountType() {
      if (this.settingsData) {
        this.settingsData.rentalAccountTypes.push("");
      }
    },

    removeRentalAccountType(index: number) {
      if (this.settingsData) {
        this.settingsData.rentalAccountTypes.splice(index, 1);

        delete this.toValidate["rentalAccountTypes-" + index];
      }
    },

    addBusinessHours() {
      if (this.settingsData) {
        this.settingsData.businessHours.push({ ...defaultBusinessHoursJson() });
      }
    },

    removeBusinessHours(index: number) {
      if (this.settingsData) {
        this.settingsData.businessHours.splice(index, 1);

        if (this.toValidate["businessHours-" + index]) delete this.toValidate["businessHours-" + index];
      }
    },

    addHolidayPeriod(data: { beginDate: string | null; endDate: string | null }) {
      if (data.beginDate && data.endDate) {
        const beginDate = new Date(data.beginDate);
        const endDate = new Date(data.endDate);

        this.addHoliday(data.beginDate);

        let nextDate = beginDate.setDate(beginDate.getDate() + 1);

        while (nextDate <= endDate.getTime()) {
          this.addHoliday();
          nextDate += 1000 * 60 * 60 * 24;
        }
      } else if (data.beginDate && !data.endDate) {
        this.addHoliday(data.beginDate);
      } else {
        alert("Es wurde kein korrekter Zeitraum angegeben.");
      }
    },

    addHoliday(date: string | null = null) {
      if (this.settingsData) {
        if (date) {
          this.settingsData.holidays.push(date);
        } else {
          const lastHoliday = this.settingsData.holidays[this.settingsData.holidays.length - 1];

          var nextHoliday = "";

          if (lastHoliday) {
            let date = DateFormatter.parseISODate(lastHoliday);

            if (date != null) {
              nextHoliday = DateFormatter.formatISODate(new Date(date.setDate(date.getDate() + 1)));
            }
          }

          this.settingsData.holidays.push(nextHoliday);
        }
      }
    },

    removeHoliday(index: number) {
      if (this.settingsData) {
        this.settingsData.holidays.splice(index, 1);

        if (this.toValidate.holidays && this.toValidate.holidays["holiday-" + index])
          delete this.toValidate["holidays"]["holiday-" + index];
      }
    },

    removeAllHolidays() {
      if (this.settingsData) {
        let c = confirm("Wollen Sie wirklich alle Einträge unwiderruflich löschen?");
        if (c == true) {
          this.settingsData.holidays = [];

          delete this.toValidate["holidays"];
        } else {
          //do nothing
        }
      }
    },

    /*** START control cached data ***/

    /* set cached data */

    /* format and set data where be cached */

    /*** END control cached data ***/

    sortBusinessHours() {
      if (this.settingsData) {
        console.log("sort");

        this.settingsData.businessHours.sort((a: BusinessHoursJson, b: BusinessHoursJson) => {
          if (a.weekDay < b.weekDay) {
            return -1;
          } else if (a.weekDay > b.weekDay) {
            return 1;
          } else {
            if (a.beginTime.replace(":", "") < b.beginTime.replace(":", "")) {
              return -1;
            } else if (a.beginTime.replace(":", "") > b.beginTime.replace(":", "")) {
              return 1;
            } else {
              return 0;
            }
          }
        });
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    settingsData: {
      deep: true,
      handler() {
        this.hasChanges = true;
      },
    },

    hasChanges: {
      deep: true,
      handler() {
        this.$emit("changesInChild", this.hasChanges);
      },
    },
  },
  computed: {
    rentalBookingUntilDate: {
      get(): string | undefined {
        if (this.settingsData != null) {
          if (this.settingsData.rentalBookingUntilDate == null) {
            return "";
          } else {
            return this.settingsData.rentalBookingUntilDate;
          }
        }
      },
      set(value: string) {
        if (this.settingsData != null) {
          if (value == "") {
            this.settingsData.rentalBookingUntilDate = null;
          } else {
            this.settingsData.rentalBookingUntilDate = value;
          }
        }
      },
    },
  },
});
